import { useTranslation } from 'react-i18next'

import { Switch } from '@reveni-io/reveni-ui'

import useCustomerNotification from './hooks/useCustomerNotification'
import LanguageSelector from './LanguageSelector/LanguageSelector'
import * as Styles from './styles'

const CustomerNotification = () => {
  const { t } = useTranslation()
  const {
    handleLanguageChange,
    handleSendCustomerNotificationChange,
    selectedLanguage,
    supportedLanguages,
    sendCustomerNotification,
  } = useCustomerNotification()

  const handleSwitchChange = e => {
    handleSendCustomerNotificationChange(e.target.checked)
  }

  return (
    <Styles.Container>
      <Switch label={t('Notificar al cliente')} checked={sendCustomerNotification} onChange={handleSwitchChange} />
      <LanguageSelector
        supportedLanguages={supportedLanguages}
        selectedLanguage={selectedLanguage}
        onChange={handleLanguageChange}
      />
    </Styles.Container>
  )
}

export default CustomerNotification
